import type { TimelineSession as TimelineSessionType } from "../../lib/timeline-loader";
import { MarkdownRenderer } from "./MarkdownRenderer";

function formatGermanDate(iso: string): string {
  const d = new Date(`${iso}T00:00:00`);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("de-DE", {
    weekday: "short",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function TimelineSession({ session }: { session: TimelineSessionType }) {
  const num = String(session.meta.session).padStart(2, "0");
  const id = `session-${num}`;
  const dateLabel = session.meta.date
    ? formatGermanDate(session.meta.date)
    : "Termin folgt";

  return (
    <section
      id={id}
      className="timeline-session relative pl-8 transition-colors hover:bg-bg-elevated/40 md:pl-12"
    >
      <span
        aria-hidden
        className="timeline-dot absolute left-2 top-3 h-3 w-3 rounded-full bg-accent md:left-4"
      />

      <header className="space-y-1 pt-1">
        <p className="text-xs font-medium uppercase tracking-wider text-fg-muted">
          Session {num}
        </p>
        <h2 className="text-2xl font-semibold tracking-tight md:text-3xl">
          <a
            href={`#${id}`}
            className="no-underline hover:text-accent"
          >
            {session.meta.title}
          </a>
        </h2>
        <p className="italic text-fg-muted">{session.meta.subtitle}</p>
        <p className="text-sm text-fg-muted">
          <span>{session.meta.duration}</span>
          <span className="px-2">·</span>
          <span>{dateLabel}</span>
        </p>
        {session.meta.focus ? (
          <p className="pt-2 text-sm text-fg">
            <span className="font-medium">Fokus: </span>
            <span className="text-fg-muted">{session.meta.focus}</span>
          </p>
        ) : null}
      </header>

      <div className="pt-4 pb-10">
        <MarkdownRenderer>{session.body}</MarkdownRenderer>

        {session.meta.homework ? (
          <p className="mt-6 text-sm text-fg">
            <span className="font-medium">Hausaufgabe: </span>
            <span className="text-fg-muted">{session.meta.homework}</span>
          </p>
        ) : null}
      </div>
    </section>
  );
}
